<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import { iButton, iFeaturedIconTypes } from '@inscribe/signal';
import DecisionEngineCard from '@/V2/decision-engine/DecisionEngineCard.vue';
import EmptyPage from '@/V2/components/EmptyPage';
import BlocklistDelete from '@/V2/decision-engine/blocklist/BlocklistDelete.vue';
import BlocklistUpload from '@/V2/decision-engine/blocklist/BlocklistUpload.vue';

export default {
  components: {
    BlocklistDelete,
    BlocklistUpload,
    DecisionEngineCard,
    EmptyPage,
    iButton,
  },
  data() {
    return {
      isLoading: true,
      iFeaturedIconTypes,
      blockToBeDeleted: null,
      uploadModalVisibile: false,
    };
  },
  computed: {
    ...mapGetters(['isOrgAdmin', 'getBlocklist']),
    ...mapActions(['loadBlocklist']),
  },
  mounted() {
    this.loadBlocklist.then(() => {
      this.isLoading = false;
    });
  },
  methods: {
    ...mapMutations(['setCurrentEditingItem']),
    onDeleteClick(params) {
      this.$emit('hide-tooltips');
      this.blockToBeDeleted = params.item;
    },
    onEditClick(params) {
      this.$emit('hide-tooltips');
      this.setCurrentEditingItem(params.item);
      this.$router.push({
        name: 'decision-engine-blocklist-edit',
      });
    },
    uploadDatabase() {
      this.uploadModalVisibile = true;
    },
    createBlocklist() {
      const newBlocklist = {
        address: {
          raw: '',
          normalised: '',
        },
        id: '',
        inEdit: true,
        name: '',
      };
      this.setCurrentEditingItem(newBlocklist);
      this.$router.push({
        name: 'decision-engine-blocklist-edit',
      });
    },
    getBlockTitle(entry) {
      return entry.name;
    },
    getBlockSubtitle(entry) {
      return entry.address?.normalized || entry.address?.raw || '';
    },
  },
};
</script>

<template>
  <div class="blocklist">
    <div class="content d-flex flex-column i-gap-12">
      <!-- header -->
      <div class="d-flex justify-content-between align-items-center">
        <div class="text flex-grow-1">
          <div class="i-text-heading-5 i-text-neutral-120 i-mb-2">
            Blocklist
          </div>
          <div class="i-text-body-2 i-text-neutral-110 subheading-wrap">
            Catch repeat offenders by adding their details to a blocklist.
          </div>
        </div>
        <div class="d-flex flex-shrink-0 i-gap-4">
          <i-button
            v-if="isOrgAdmin"
            text="Upload Database"
            type="neutral"
            subtype="outline"
            size="md"
            @button-click="uploadDatabase()"
          ></i-button>
          <i-button
            v-if="isOrgAdmin"
            text="New Blocklist"
            data-testid="new-blocklist-button"
            size="md"
            @button-click="createBlocklist()"
          ></i-button>
        </div>
      </div>

      <!-- empty card -->
      <empty-page
        v-if="getBlocklist.length === 0 && !isLoading"
        class="d-flex flex-grow-1"
        icon="large-ai-spark-document"
        title="Start by adding a customer to the blocklist"
        subtitle="All of your blocklist details will appear here."
        button-text="New Blocklist"
        secondary-button-text="Upload Database"
        @on-button-click="createBlocklist()"
        @on-secondary-button-click="uploadDatabase()"
      ></empty-page>

      <div
        v-if="getBlocklist.length > 0 && !isLoading"
        class="blocks-list rules-list items-list i-radius-2xl"
        data-testid="blocklist-rules-list"
      >
        <decision-engine-card
          v-for="(entry, index) in getBlocklist"
          :key="index"
          :title="getBlockTitle(entry)"
          :subtitle="getBlockSubtitle(entry)"
          :item="entry"
          icon="medium-user-delete"
          :icon-type="iFeaturedIconTypes.ERROR"
          tooltip-toggle-on="Disable Details"
          tooltip-toggle-off="Enable Details"
          tooltip-edit="Edit Details"
          tooltip-delete="Delete Details"
          @delete-click="onDeleteClick"
          @edit-click="onEditClick"
          @card-click="onEditClick"
        ></decision-engine-card>
      </div>
    </div>

    <!-- delete -->
    <blocklist-delete
      :block-to-be-deleted="blockToBeDeleted"
      @on-close="blockToBeDeleted = null"
    ></blocklist-delete>

    <!-- upload database -->
    <blocklist-upload
      :visible="uploadModalVisibile"
      @on-close="uploadModalVisibile = false"
    ></blocklist-upload>
  </div>
</template>

<style lang="scss" scoped>
.blocklist {
  height: 100%;

  .content {
    height: 100%;
  }
}
</style>
